import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { ThemeProvider } from 'styled-components';
import { useChart } from './useChart';
import { theme } from '../../../../../../../../theme/theme';
import { Tooltip } from '../Tooltip/Tooltip';
import { Card } from '../../../../../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { Wrapper } from '../../../../../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { MarginProps } from '../../../../../../../../theme/styledProps';
import { SplineChartLoading } from '../../../../../../../../CommonComponents/OPL/charts/SplineChart/SplineChart.loading';
import { MemoSplineChart } from '../MemoSplineChart/MemoSplineChart';
import { useChartReflow } from '../../../../../../hooks/useChartReflow';

interface Props extends MarginProps {
  isPrint?: boolean;
}

export const Chart: React.FC<Props> = ({ isPrint, ...rest }) => {
  const { data, isFetching } = useChart();
  const { chartRef } = useChartReflow();

  if (isFetching) {
    return (
      <Wrapper {...rest}>
        <Card p="16">
          <Text fontSize="h6" fontWeight={600} color="neutral.700" mb="16">
            Monte Carlo Trials
          </Text>
          <SplineChartLoading />
        </Card>
      </Wrapper>
    );
  }

  if (!data) {
    return null;
  }

  const { series, categories, probabilityOfFailure, probabilityOfSuccess } = data;

  const chartConfig = {
    chart: {
      height: isPrint ? 320 : 400,
    },
    tooltip: {
      formatter() {
        return ReactDOMServer.renderToStaticMarkup(
          <ThemeProvider theme={theme}>
            <Tooltip
              probabilityOfSuccess={probabilityOfSuccess}
              probabilityOfFailure={probabilityOfFailure}
            />
          </ThemeProvider>,
        );
      },
    },
  };

  return (
    <Wrapper {...rest}>
      <Card p="16">
        <Text fontSize="h6" fontWeight={600} color="neutral.700" mb="16">
          Monte Carlo Trials
        </Text>
        <MemoSplineChart
          series={series}
          categories={categories}
          ref={chartRef}
          customSettings={chartConfig}
        />
      </Card>
    </Wrapper>
  );
};
